import { useEffect, useRef, useState } from 'react';
import { useClaimReward } from '@/api/hooks';
import { useUi } from '@/app/store';
import { Sheet } from '@/components/Sheet';
import { platform } from '@/platform';

/** Календарь ежедневной награды. Клейм происходит при открытии. */
export function DailyRewardSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  const claim = useClaimReward();
  const toast = useUi((s) => s.showToast);
  const [result, setResult] = useState<{ reward: number | 'ticket'; dayIndex: number; schedule: (number | 'ticket')[] } | null>(null);

  const started = useRef(false);
  useEffect(() => {
    if (!open) { started.current = false; setResult(null); return; }
    if (started.current) return; // StrictMode / повторный рендер — один клейм
    started.current = true;
    claim.mutateAsync().then((r) => { platform.haptic('success'); setResult({ reward: r.reward, dayIndex: r.dayIndex, schedule: r.user.dailyReward.schedule }); })
      .catch((e: Error) => { toast(e.message, true); onClose(); });
  }, [open]);

  return (
    <Sheet open={open} onClose={onClose}>
      {result ? (
        <div className="stack center">
          <h2>Ежедневная награда</h2>
          <div className="reward-grid">
            {result.schedule.map((s, i) => <div key={i} className={`reward-day${i < result.dayIndex ? ' done' : ''}${i === result.dayIndex ? ' today' : ''}`}>{s === 'ticket' ? '🎟' : `💎${s}`}</div>)}
          </div>
          <div style={{ fontSize: 40 }}>{result.reward === 'ticket' ? '🎟' : '💎'}</div>
          <p>{result.reward === 'ticket' ? 'Билет на крутку!' : `+${result.reward} кристаллов`}</p>
          <button className="btn primary" onClick={onClose}>Забрать</button>
        </div>
      ) : (
        <div className="skeleton" style={{ height: 160 }} />
      )}
    </Sheet>
  );
}
